import SideBar from "../../../components/SideBar";
import { Main } from "../../styled";
import arvore_image from "../../../../assets/arvore.png";
import perfil_image from "../../../../assets/perfil.png";
import informations_icon from "../../../../assets/icons/informations.svg";
import lista_participantes_icon from "../../../../assets/icons/lista_participantes.svg";
import mail_icon from "../../../../assets/icons/mail.svg";
import InputSearch from "../../../components/InputSearch";
import CardGrupo from "../../../components/Cards/CardGrupo";
import { Content } from "./styled";
import PostagemInput from "../../../components/PostagemInput";
import CardPostagem from "../../../components/Cards/CardPostagem";
import CircularImage from "../../../components/CircularImage";
import { tiposPublicacao } from "../../../../utils/data";
import arrow_back_icon from "../../../../assets/icons/arrow-back.svg";
import { useState } from "react";
import ControllerGrupo from "./controller";
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "../../../../utils/config";
import Loading from "../../../components/Loading";
import Esqueleto, { Recarregando } from "../../../components/Esqueleto";
import Postagem from "../../../../models/Postagem";
import TagsList from "../../../components/TagsList";
import Comentar from "../../Forum/Comentar";
import InformacoesGrupoModal from "../InformacoesGrupo/InformacoesGrupoModal";
import ListaParticipantesModal from "../ListaParticipantesModal";
import SolicitacoesPendentesModal from "../SolicitacoesPendentesModal";
import NovoGrupoModal from "../NovoGrupoModal";
import Abas from "../../../components/Abas";
import ImagemCarregando from "../../../components/ImagemCarregando";
import ModalSolicitarProfissional from "../../../components/ModalSolicitarProfissional";
import { ehProfissional } from "../../../../utils/papeis";
import Grupo from "../../../../models/Grupo";
import DeleteDialog from "../../../components/DeleteDialog";
import Toast from "../../../components/Toast";

function Grupos({usuario, errors, setErrors}){
  const {id} = useParams();
  const navigate = useNavigate();
  const [postagem, setPostagem] = useState({...Postagem.model});
  const [postagens, setPostagens] = useState();
  const [subgrupos, setSubgrupos] = useState();
  const [loading, setLoading] = useState(false);
  // Subgrupos/postagens carregando: esqueleto. `loading` (overlay) so na entrada no grupo e ao gravar.
  const [carregandoLista, setCarregandoLista] = useState(true);
  const [grupo, setGrupo] = useState();
  const [postagemSelected, setPostagemSelected] = useState();
  const [showInformacoesGrupoModal, setShowInformacoesGrupoModal] = useState(false);
  const [showNovoSubgrupoModal, setShowNovoSubgrupoModal] = useState(false);
  const [showPedidoPro, setShowPedidoPro] = useState(false);
  const [showListaParticipantesModal, setShowListaParticipantesModal] = useState(false);
  const [showSolicitacoesPendentesModal, setShowSolicitacoesPendentesModal] = useState(false);
  // Aba da area principal: 'postagens' (padrao) ou 'subgrupos'. So aparece quando o grupo
  // TEM subgrupos; antes as postagens sumiam atras de uma secao "Grupos" generica.
  const [aba, setAba] = useState("postagens");
  const [loadingSubtitulo, setLoadingSubtitulo] = useState();
  const [tag, setTag] = useState();
  const [tags, setTags] = useState();
  const [midia, setMidia] = useState();
  const [page, setPage] = useState(1);

  // ----- Sair do grupo/subgrupo -----
  // Regra: quem e o UNICO administrador nao sai (so exclui o grupo, ou nomeia outro
  // administrador antes). O servidor tambem barra (409); aqui nao se oferece o botao.
  const [aviso, setAviso] = useState("");
  const [confirmaSair, setConfirmaSair] = useState(false);
  useEffect(() => {
    if (!aviso) return undefined;
    const t = setTimeout(() => setAviso(""), 8000);
    return () => clearTimeout(t);
  }, [aviso]);

  const palavraGrupo = grupo?.tipo === "Subgrupo" ? "subgrupo" : "grupo";
  const outrosAdmins = (grupo?.administradores || []).filter((a) => a.is_admin && a.usuario?.id !== usuario.id).length;
  // `is_membro` = vinculo ativo de verdade. O administrador do GRUPO PAI e participante
  // efetivo do subgrupo (is_participante) sem ter vinculo: para ele nao ha 'Sair' nem dica.
  const ehMembro = grupo?.is_membro ?? grupo?.is_participante;
  const ehUnicoDono = !!ehMembro && !!grupo?.is_admin && outrosAdmins === 0;
  const podeSair = !!ehMembro && !ehUnicoDono;

  async function sairDoGrupo() {
    setConfirmaSair(false);
    setLoading(true);
    const r = await Grupo.sair(usuario.id, grupo.id);
    setLoading(false);
    if (r?.status === 200) {
      navigate(grupo?.grupo_pai_id ? `/grupos/${grupo.grupo_pai_id}` : "/grupos");
      return;
    }
    const resp = r?.response;
    // regra de negocio (409 + codigo): aviso amigavel, nao erro
    if (resp?.status === 409 && resp?.data?.codigo) { setAviso(resp.data.message || resp.data.error); return; }
    setErrors({ ...errors, geral: resp?.data?.message || resp?.data?.error || "Não foi possível sair agora. Tente novamente." });
    setTimeout(() => setErrors({ ...errors, geral: "" }), 4000);
  }

  // Criar SUBGRUPO e do perfil Profissional (regra de negocio; o backend recusa os
  // demais com 403). Grupo principal e livre. Quem nao tem o perfil ve o pedido em
  // vez de preencher um formulario que falharia no fim.
  function abrirSubgrupo(){
    if(ehProfissional(usuario)) setShowNovoSubgrupoModal(true);
    else setShowPedidoPro(true);
  }

  const controllerGrupo = new ControllerGrupo(usuario, grupo, errors, postagem, midia, setPostagem, setPostagens, setMidia, setErrors, setLoading, setCarregandoLista);

  // "Voltar": de uma postagem aberta volta para a lista; fora disso sai do grupo para a
  // tela anterior (o grupo pai, num subgrupo, ou a lista de Grupos). Antes so tratava o
  // primeiro caso: no grupo o botao NAO fazia nada, porque so "desselecionava" uma
  // postagem que nao existia.
  function voltarAtras(){
    if (postagemSelected) return controllerGrupo.voltar(setPostagemSelected);
    navigate(grupo?.grupo_pai_id ? `/grupos/${grupo.grupo_pai_id}` : "/grupos");
  }


  useEffect(()=>{
    controllerGrupo.findGrupoById(setGrupo, id);
    controllerGrupo.findSubgruposByGrupoId(setSubgrupos, id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(()=>{
    controllerGrupo.findPostagensByGrupoId(setPostagens, page, id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, id]);

  useEffect(()=>{
    controllerGrupo.findTags(tag, setTags);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tag]);

  return(
    <SideBar>
      <Main>
        { loading && <Loading/> }
        <Toast variante="info" error={aviso} />
        <Toast error={errors.geral} />
        {confirmaSair && <DeleteDialog
          titulo={`Sair do ${palavraGrupo}?`}
          subtitulo={`Você deixará de ver as postagens deste ${palavraGrupo}. Para voltar, será preciso pedir para participar de novo.`}
          textButton="Sair"
          onClose={()=>setConfirmaSair(false)}
          onDelete={sairDoGrupo}
        />}
        { showInformacoesGrupoModal && <InformacoesGrupoModal onClose={()=>setShowInformacoesGrupoModal(false)} grupo={grupo} setGrupo={setGrupo} subgruposCount={subgrupos?.count || 0}/>}
        { showListaParticipantesModal && <ListaParticipantesModal onClose={()=>setShowListaParticipantesModal(false)} grupo={grupo}/>}
        { showSolicitacoesPendentesModal && <SolicitacoesPendentesModal onClose={()=>setShowSolicitacoesPendentesModal(false)} grupo={grupo}/>}
        { showNovoSubgrupoModal && <NovoGrupoModal onClose={()=>setShowNovoSubgrupoModal(false)} grupo_pai={grupo} atualizarGrupos={async ()=>{ await controllerGrupo.findSubgruposByGrupoId(setSubgrupos, id); setAba("subgrupos"); }} />}
        { showPedidoPro && <ModalSolicitarProfissional onClose={()=>setShowPedidoPro(false)} />}

        <Content className="content" id="content">
          <button className="back" id="button-back" onClick={voltarAtras}>
            <img src={arrow_back_icon} alt="Icone de voltar"/>
            <span> Voltar </span>
          </button>

          <section>
            <div className="top">
              <div className="title">
                <h2>Grupo</h2>
                <span className="nome-com-capa">
                  {grupo?.foto_capa?.path &&
                    <ImagemCarregando className="capa-miniatura" src={grupo.foto_capa.path} alt={`Capa de ${grupo?.nome}`} />}
                  {grupo?.nome}
                </span>
              </div>
              <InputSearch text="Pesquisar grupo"/>
            </div>
          </section>

          <div className="panel">
            {
              !postagemSelected ?
              <section className="left-section">
                {subgrupos?.count > 0 &&
                  <Abas
                    abas={[{ id: "postagens", rotulo: "Postagens" }, { id: "subgrupos", rotulo: `Subgrupos (${subgrupos.count})` }]}
                    ativa={aba} onChange={setAba} idBase="grupo" rotulo="Conteúdo do grupo"
                  />
                }

                {(!(subgrupos?.count > 0) || aba === "postagens") && <>
                <PostagemInput 
                  errors={errors}
                  postagem={postagem} 
                  midia = {midia}
                  onChange={(e)=>controllerGrupo.validarTexto(e, setTag)} 
                  onSubmit={(e)=>controllerGrupo.handleSubmit(e, setLoadingSubtitulo)}
                  onSelectMidia={(e)=>controllerGrupo.handleSelectMidia(e, setMidia)}
                />
                
                {(tag && tag !== "#" && tags?.rows?.length > 0) && 
                  <TagsList tags={tags} onSelect={(nome)=>controllerGrupo.completaTag(nome, setTag)}/> 
                }
                </>}
                

                { !(subgrupos?.count > 0) || aba === "postagens" ?
                  <section className="postagens-section">
                    <h3>Postagens</h3>

                    {!postagens && carregandoLista && <Esqueleto variante="linha" quantidade={4} rotulo="Carregando postagens" />}
                    {

                      (!postagens && carregandoLista) ? null :
                      postagens?.rows?.length > 0 ?
                      <Recarregando $ativo={carregandoLista} aria-busy={carregandoLista}>
                        {postagens?.rows?.map((postagem) => (
                          <CardPostagem 
                            key={`post-${postagem.id}`}
                            postagem={postagem}
                            tipo={tiposPublicacao.POSTAGEM}
                            handleLike={()=>controllerGrupo.handleLike(postagem, postagens)}
                            handleComentar= {()=>controllerGrupo.selecionaPostagem(setPostagemSelected, postagem, postagens)}
                          />
                        ))}
                        { postagens.rows.length !== postagens.count &&
                          <span className="more" onClick={()=>setPage(page+1)}> Ver mais </span>
                        }
                        {carregandoLista && page > 1 && <Esqueleto variante="linha" quantidade={2} rotulo="Carregando mais postagens" />}
                      </Recarregando>:
                      <div className="painel-empty">
                        <img src={arvore_image} alt="Icone de uma árvore"/>
                        <span>Ainda não há nada aqui. Seja o primeiro a fazer uma postagem...</span>
                      </div>
                    }
                  </section> :
                  <section className="grupos-section">
                    <h3>Subgrupos de {grupo?.nome}</h3>
                    {carregandoLista && !subgrupos && <Esqueleto variante="cartao" quantidade={3} rotulo="Carregando subgrupos" />}
                    <div className="grupos-list">
                      {
                        subgrupos?.rows?.map(subgrupo=>
                          <CardGrupo key={`sub-${subgrupo.id}`} textButton={"Abrir subgrupo"} grupo={subgrupo} link={`/grupos/${subgrupo?.id}`}/>
                        )
                      }
                    </div>
                  </section>
                }
              </section>
              :
              <Comentar postagemSelected={postagemSelected} setPostagemSelected={setPostagemSelected} handleLike={()=>controllerGrupo.handleLike(postagemSelected, postagens)}/>
            }

           <section className="right-section">

              {
                grupo?.is_admin ?
                <section className="actions-section"> 
                  <div className="action-item" onClick={()=>setShowInformacoesGrupoModal(true)}>
                    <img src={informations_icon} alt="Icone de informações"/>
                    <span>Informações do {grupo?.tipo === "Subgrupo" ? "subgrupo" : "grupo"}</span>
                  </div>
                  <div className="action-item" onClick={()=>setShowListaParticipantesModal(true)}>
                    <img src={lista_participantes_icon} alt="Icone de informações"/>
                    <span>Lista de participantes</span>
                  </div>
                  {grupo?.tipo === "Grupo Principal" && 
                    <>
                      <div className="action-item" onClick={()=>setShowSolicitacoesPendentesModal(true)}>
                        <img src={mail_icon} alt="Icone de mensagens"/>
                        <span>Solicitações pendentes</span>
                      </div>
                    
                      <div className="action-item" onClick={abrirSubgrupo}>
                        <img src={informations_icon} alt="Icone de informações"/>
                        <span>Criar subgrupo</span>
                      </div>
                    </>
                  }
                </section> :   
                <section className="admins-section">
                  <h3>Administradores</h3> 
                  {
                    grupo?.administradores?.map(administrador=>
                      <div className="admin-profile">
                        <CircularImage src={administrador?.usuario?.foto_perfil?.path || perfil_image} alt="Foto de perfil do participante"/>
                        <span>{administrador?.usuario?.nome}</span>
                      </div>
                    )
                  }
                
                </section>
              }

              <section className="participantes-section">
                <h3>Participantes</h3> 

                <div className="list">
                  {grupo?.grupos_usuarios?.map(grupo_usuario=>
                    <CircularImage src={grupo_usuario?.usuario?.foto_perfil?.path || perfil_image} alt="Foto de perfil do participante"/>
                  )}
                  
                </div>

                <span>Você {grupo?.quantidade_usuarios > 1 &&  `e mais ${grupo?.quantidade_usuarios-1 || 'alguns'} participantes` } </span>
              </section>

              {ehMembro &&
                <section className="sair-section" aria-label={`Sair do ${palavraGrupo}`}>
                  {podeSair
                    ? <button type="button" className="sair-grupo" onClick={()=>setConfirmaSair(true)}>Sair do {palavraGrupo}</button>
                    : <p className="dica-dono" role="note">
                        Você é o único administrador deste {palavraGrupo}, por isso não há a opção de sair.
                        Para encerrar, use <strong>Deletar {palavraGrupo}</strong> em “Informações do {palavraGrupo}”;
                        ou nomeie outro administrador antes de sair.
                      </p>}
                </section>
              }

              {/* <section className="semelhantes-section">
                <h3>Grupos Semelhantes</h3>
                {
                  Array.from({ length: 3 }).map((_, index) => (
                    <CardGrupo details={false}/>
                  ))
                }
              </section> */}

            </section>
          </div>
        </Content>
      </Main>
    </SideBar>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Grupos);